import {
  LocationDashboardSchema,
  OrganisationOverviewSchema,
  type LocationDashboard,
} from "@safeplate/contracts";

import { requestApi } from "../api/client.js";

export type LocationDashboardMetrics = LocationDashboard;

export async function getLocationDashboard(
  locationId: string,
): Promise<LocationDashboardMetrics> {
  return LocationDashboardSchema.parse(
    await requestApi(`/locations/${locationId}/today`),
  );
}

export async function getOrganisationOverview() {
  return OrganisationOverviewSchema.parse(
    await requestApi("/orgs/current/overview"),
  );
}
